import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider_2_TirthYatra({ section }) {
  const [isScrolled, setIsScrolled] = useState(false);
  
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
        {
            breakpoint: 768, // Mobile screens
            settings: {
                slidesToShow: 1,
            },
        },
        {
            breakpoint: 1024, // Tablet screens
            settings: {
                slidesToShow: 2,
            },
        },
    ],
};


  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsScrolled(scrollTop > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div class="banner-sec-tours mb-5">
    <div class="container">
      <div class="popular-state pb-0 pt-0">
        <div class="title text-center">
          <h3 class="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Explore </span>} {section?.title || 'The Hidden Gems'}</h3>
          <p class="max-width-100">{section?.subtitle || 'Tap into the untapped tourist spots for amazing vacations.'}</p>
        </div>
      </div>
      <div className={`tours-banner-sec-home slider slides-wrapper pt-5 ${
                        isScrolled ? "slide" : ""
                        }`}>
      {/* <div class="tours-banner-sec-home slider slides-wrapper"> */}
      <Slider {...settings}>
        {(section?.Items?.length ? section.Items : [
          { image_url: 'assets/img/home/tours/1.png', title: 'Slide 1' },
          { image_url: 'assets/img/home/tours/2.png', title: 'Slide 2' },
          { image_url: 'assets/img/home/tours/3.png', title: 'Slide 3' },
          { image_url: 'assets/img/home/tours/4.png', title: 'Slide 4' },
        ]).map((item, index) => (
        <div class="slide" key={index}>
          <img src={item.image_url} class="br-12" alt={item.title} />
        </div>
        ))}
      </Slider>
      </div>
    </div>
  </div>
  
  );
}

export default Slider_2_TirthYatra;
